import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

class SavingIndicator extends Component {
  render() {
    const className = classnames({
      'saving-indicator': true,
      'saving-indicator--show': this.props.savingInstance.saving
    })

    const spinnerClassName = classnames({
      'saving-indicator-bar': true,
      'saving-indicator-bar--loaded': !this.props.savingInstance.saving,
      'saving-indicator-bar--error': this.props.savingInstance.error
    })

    return (
      <div className={className}>
        <div className={spinnerClassName}></div>
      </div>
    )
  }
}

SavingIndicator.propTypes = {
  savingInstance: PropTypes.object
}

SavingIndicator.defaultProps = {
  savingInstance: {}
}

export default SavingIndicator



// WEBPACK FOOTER //
// ./src/components/common/saving-indicator.js